// extracted by mini-css-extract-plugin
export default {"dropdown":"_3wOZdsh93rDhp-iu9wlyas","chip":"_2BvAxrqdTbnLLhzDzeE-MP","chipTitle":"dYIiqXEaN5OzRumqjmvWE"};